import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import moment from 'moment';
declare var require: any;
declare var bootstrap: any;
declare var what3words: any;

@Component({
  selector: 'app-alert-page',
  templateUrl: './alert-page.component.html',
  styleUrls: ['./alert-page.component.scss']
})
export class AlertPageComponent implements OnInit {

  alert: any = null;
  alert_id: any = null;
  notes: any;
  id?: number;

  formGroup = new FormGroup({
    notes: new FormControl('',[Validators.required])
  });

  verifyGroup = new FormGroup({
    type: new FormControl('',[]),
    information: new FormControl('',[])
  });
  edit_verify_info = false;

  submitted = false;

  check_Actions = true;

  view_notes = true;

  get f(): { [key: string]: AbstractControl } {
    return this.verifyGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    this.alert_id = +this.route.snapshot.params['id'];

    //console.log('id',this.alert_id);

    this.getAlert();

  }

  getAlert(){

    this.okService.get("alerts/"+this.alert_id,{'expand': 'worker,status,escalation_procedure,shift,company,messages,vehicle,verify,activity,connectivity,arc_actions'})
    .subscribe((data) => {

      this.alert = data.body;

      //console.log("Alert",this.alert);

      this.checkActions();
      this.setVerify();

    });

  }

  // See if there is an action in the params
  checkActions(){
    if(this.check_Actions){
      this.check_Actions = false;
      const action = this.route.snapshot.queryParamMap.get('action');
      if(action && this.alert){
        if(action == "accept"){
          this.acceptAlert(this.alert);
        }else if(action == "acknowledge"){
          this.acknowledgeAlert(this.alert);
        }else if(action == "resolve"){
          this.resolveAlert(this.alert);
        }
      }
    }
  }

  // setForm(){
  //   this.formGroup.setValue({
  //     notes: this.alert.notes
  //   });
  // }

  addNotes(){
    this.submitted = true;

    if(this.formGroup.valid){

      let notes = this.formGroup.value;
      //console.log('notes send',notes);
      this.okService.put("alerts/update-notes/"+this.alert_id,{'notes':notes.notes})
      .subscribe((data) => {

        this.formGroup.setValue({
          notes: null
        });

        //console.log('notes return',data.body);

        this.getAlert();

        this.okService.setAlert(this.transloco.translate("The alert notes have been updated"),"success");

      })
    }

  }

  acceptAlert(alert:any){

    this.okService.put("alerts/accept/"+alert.id,{})
    .subscribe((data) => {

      this.getAlert();

      this.okService.setAlert(this.transloco.translate("The alert has been accepted"),"success");



    });

  }

  acknowledgeAlert(alert:any){

    this.okService.put("alerts/acknowledge/"+alert.id,{})
    .subscribe((data) => {

      this.getAlert();

      this.okService.setAlert(this.transloco.translate("The alert has been acknowledged"),"success");


    });

  }

  resolveAlert(alert:any){

    this.okService.put("alerts/resolve/"+alert.id,{})
    .subscribe((data) => {

      this.getAlert();

      this.okService.setAlert(this.transloco.translate("The alert has been resolved"),"success");


    });

  }

  lastKnownLocationTime(){
    let date = new Date();
    let time = date.getTime();

    let timeSince = Math.round(((time - this.alert.status.loc_unix)/60000));

    return timeSince;

  }

  whatWords(alert:any){

    let coordinates = alert.status.loc_lat+","+alert.status.loc_lng;

    this.okService.get("account/what3words",{'coordinates':coordinates})
    .subscribe((data:any) => {

      alert.w3w = data.body;

    });

  }

  isString(val:any): boolean { return typeof val === 'string'; }



  verifyAlert(){

    if(this.verifyGroup.valid){

      let verify = this.verifyGroup.value;

      this.okService.post("alerts/verify/"+this.alert.id,{'verify':verify})
      .subscribe((data) => {

        this.getAlert();

        this.edit_verify_info = !this.edit_verify_info;
        this.okService.setAlert(this.transloco.translate("The alert category and information has been saved."),"success");

      });

    }

  }

  verifyAlertClicked(type:any){
    this.f['type'].setValue(type);
    this.verifyAlert();
    //this.editVerifyInfo();
  }

  editVerifyInfo(){
    //console.log("editVerifyInfo");
    this.edit_verify_info = true;
  }

  cancelEditVerifyInfo(){
    this.edit_verify_info = false;
  }


  setVerify(){

    if(this.alert.verify != null){

      this.verifyGroup.setValue({
        type: this.alert.verify.type,
        information: this.alert.verify.information
      });

    }

  }

  exportAlert(){
    const data = document.getElementById("alert-export");
    console.log('export alert');
    if(data){
      html2canvas(data,{allowTaint:true,useCORS:true}).then(canvas => {
        console.log('html2canvas');
        const imgWidth = 200;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        const contentData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p','mm','a4');
        const position = 0;
        pdf.addImage(contentData,'PNG',0,position,imgWidth,imgHeight);
        pdf.save('alert-export');
      })
    }
  }

}
